// Return nothing if this is native only properties and this is not native
export default () => {};
